import { useEffect, useRef, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { apiClient } from "@/lib/api";
import { useAuth } from "@/lib/auth";

// Handles the return leg of Emergent-managed Google sign-in.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");
  const nav = useNavigate();
  const { refreshMe } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sessionId = m ? decodeURIComponent(m[1]) : "";
    // Clear the fragment so the session_id never lingers in the URL/history
    window.history.replaceState(null, "", window.location.pathname);
    if (!sessionId) {
      nav("/login", { replace: true });
      return;
    }
    apiClient
      .post("/auth/sso/session", { session_id: sessionId })
      .then(async () => {
        const u = await refreshMe();
        nav(u?.role === "customer" ? "/portal/tickets" : "/", { replace: true });
      })
      .catch((e) => {
        setError(e?.response?.data?.detail || "Google sign-in failed — please try again.");
      });
  }, [nav, refreshMe]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#fafbfc] p-6">
      <div className="card card-padded max-w-md w-full text-center" data-testid="auth-callback">
        {error ? (
          <>
            <h1 className="h1 mb-2">Sign-in problem</h1>
            <p className="text-sm text-red-600 mb-4" data-testid="sso-error">{error}</p>
            <Link to="/login" className="btn btn-primary justify-center" data-testid="sso-back-to-login">
              Back to sign in
            </Link>
          </>
        ) : (
          <div className="flex items-center justify-center gap-2 text-sm muted py-6">
            <Loader2 size={16} className="animate-spin" /> Completing Google sign-in…
          </div>
        )}
      </div>
    </div>
  );
}
